module.exports = __webpack_public_path__ + "static/automatic-ai_1-d2b23309a136db3f4eee4ab5d68d178f.jpg";